import { useCallback, Fragment } from "react";
import { Link, useParams, Outlet, useNavigate, useLocation } from "react-router-dom";

import { DEFAULT_CHAIN, CHAIN_DATA, CHAINS } from "../data/metaData";
import { ICONS } from "../data/constants";

const NavBar = () => {
    var { chain: selectedChain, id, tag } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { name, twitterLink } = CHAIN_DATA[selectedChain] || CHAIN_DATA[DEFAULT_CHAIN];
    const identifier = id || tag;
    const page = location.pathname.split('/')[2];

    const handleChangeNetwork = useCallback((event) => {
        const newLocation = `/${event.target.value}${page ? '/' + page : ''}${identifier ? '/' + identifier : ''}`;
        navigate(newLocation, { replace: true });
    }, [navigate, identifier, page]);

    const renderNavItems = () => (
        <div className="near-brand d-flex">
            <h1 className="text-assistive">{selectedChain}</h1>
            <Link className="brand-logo" to={`/${selectedChain}`}>
                <div className="wagmi33-logo" />
            </Link>
            <nav className="near-menu">
                <Link
                    className={`menu-btn ${!page ? 'active' : 'null'}`}
                    to={`/${selectedChain}`}
                >
                    Home
                </Link>
                <Link
                    className={`menu-btn ${page === 'projects' ? 'active' : 'null'}`}
                    to={`/${selectedChain}/projects`}
                >
                    Projects
                </Link>
                {/* <a className={`menu-btn ${page === 'racking' ? 'active' : 'null'}`} href="/">Ranking</a>
                <a className={`menu-btn ${page === 'articles' ? 'active' : 'null'}`} href="/">Articles</a> */}
                <a
                    className="menu-twitter text-primary"
                    href={twitterLink}
                    rel="noopener noreferrer"
                    target="_blank"
                    title={`Follow ${name} on Twitter`}
                >
                    <img className="nav-item-icon" height="16" width="16" src={ICONS['Twitter_HOME']} alt="Twitter" />
                    <span className="ml-1 hide-sm">Twitter</span>
                </a>
            </nav>
        </div>
    );

    const renderNetworkSwitch = () => (
        <div className="near-search">
            <div className="dropdown-container" id="aa-input-container">
                <span className="algolia-autocomplete" style={{position: 'relative', display: 'inline-block', direction: 'ltr'}}>
                    <select
                        id="chain-select"
                        name="chain-select"
                        onChange={handleChangeNetwork}
                        value={selectedChain}
                    >
                        {CHAINS.map((chain, index) => 
                            (<option key={`${chain}-${index}`} value={chain}>{CHAIN_DATA[chain].name}</option>)
                        )}
                    </select>
                </span>
            </div>
        </div>
    );

    return (
        <Fragment>
            <div className="section-header">
                <div className="awesome-header">
                    <div className="container grid-xl">
                        <div className="columns">
                            <div className="header-container column col-md-12">
                                {renderNavItems()}
                                {/* {renderNetworkSwitch()} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Outlet />
        </Fragment>
    );
};

export default NavBar;
